import { theme as cargillTheme } from './cargill-theme'
import { theme as hedgitTheme } from './hedgit-theme'

export const getTheme = () => {
  switch (process.env.REACT_APP_WHITE_MARK) {
    case 'cargill':
      return cargillTheme
    case 'hedgit':
      return hedgitTheme
    default:
      return hedgitTheme
  }
}
